// extracted by mini-css-extract-plugin
export default {"linkStyle":"ProgramPopup_linkStyle__u-4rg"};